import React from 'react';
import styles from './index.module.scss';

interface CTitleProps {
  title?: string;
  description?: string;
  children?: React.ReactNode;
}

const CTitle: React.FC<CTitleProps> = ({ title, description, children }) => {
  if (!title && !description) {
    return <div className={styles.titleWrapper}>{children}</div>;
  }
  return (
    <div className={`${styles.titleWrapper} ${!children && styles.noChildren}`}>
      {(title || description) && (
        <div className={styles.titleHeader}>
          {title && <div className={styles.title}>{title}</div>}
          {description && <div className={styles.description}>{description}</div>}
        </div>
      )}
      {children}
    </div>
  );
};

export default CTitle;

